import React from 'react';
import styled from 'styled-components';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FormStyle = styled.form`
  .toast {
    max-height: 20%;
    width: 20%;
  }
  width: 100%;
  .form-group {
    width: 100%;
    margin-bottom: 2rem;
  }
  label {
    font-size: 1.8rem;
  }
  input,
  textarea {
    width: 100%;
    font-size: 2rem;
    padding: 1.2rem;
    color: var(--gray-1);
    background-color: var(--deep-dark);
    outline: none;
    border: none;
    border-radius: 8px;
    margin-top: 1rem;
  }
  textarea {
    min-height: 250px;
    resize: vertical;
  }
  button[type='submit'] {
    background-color: var(--gray-1);
    color: var(--black);
    font-size: 2rem;
    display: inline-block;
    outline: none;
    border: none;
    padding: 1rem 4rem;
    border-radius: 8px;
    cursor: pointer;
  }
`;

export default function ContactForm() {
  // const [name, setName] = useState('');
  // const [email, setEmail] = useState('');
  // const [message, setMessage] = useState('');

  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_iy83w3s',
        'template_xd5xl2q',
        e.target,
        'user_0gqEsv892keAkRAVCQr1c'
      )
      .then(
        (result) => {
          toast('Email sent', { type: 'warning' });
          e.target.reset();
        },
        (error) => {
          toast('Error', { type: 'error' });
          e.target.reset();
        }
      );
  }
  return (
    <>
      {/* <FormStyle>
        <div className="form-group">
          <label htmlFor="name">
            Your Name
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="email">
            Your Email
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="message">
            Your message
            <textarea
              type="text"
              id="message"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>
        </div>
        <button type="submit">Send</button>
      </FormStyle> */}

      <FormStyle onSubmit={sendEmail}>
        <ToastContainer className="toast" />
        <ToastContainer className="toast" />
        <div className="form-group">
          <input type="text" id="name" placeholder=" Your Name" name="name" />
        </div>
        <div className="form-group">
          <input
            type="email"
            id="email"
            placeholder="Email Address"
            name="email"
          />
        </div>

        <div className="form-group">
          <textarea id="message" placeholder="Your message" name="message" />
        </div>
        {/* <div className="button">
          <input type="submit" value="Send" />
        </div> */}
        <button type="submit">Send</button>
      </FormStyle>
    </>
  );
}
